<template>
    <div style="display: contents" class="spot-caption">

        <!-- Original List Spot Caption -->
        <original-caption v-if="spot.original" :list="list" :spot="spot"></original-caption>

        <!-- Caption by Someone else not the auth user -->
        <div class="map-post-comment-wrap" v-if="!ownsList && hasCaption">

            <div v-if="isMapBlocked" class="map-blocker filters" data-modal="apply"></div>

            <div class="map-post-comment-edit-wrap">

                <div class="map-post-comment-edit on-display">

                    <a :href="`/${list.user.username}`">
                        <img :src="list.user.profile_thumbnail">
                    </a>

                    <div class="comment-content" v-if="hasLongCaption">
                        <p class="full-comment" v-if="showingFullCaption">
                            {{ currentSpot.pivot.caption }}
                            <button class="map-comment-shrink" @click="toggleShowCaption()">Less -</button>
                        </p>
                        <p class="main-comment" v-else>
                            {{ strLimit(currentSpot.pivot.caption) }}
                            <button class="map-comment-expand" @click="toggleShowCaption()">More +</button>
                        </p>
                    </div>
                    <div v-else class="comment-content">
                        <p class="main-comment" v-text="currentSpot.pivot.caption"></p>
                    </div>
                </div>
            </div>

        </div>

        <!--Owner Edit Caption Toggle -->
        <div class="map-post-comment-wrap previous" v-if="ownsList">

            <!-- Caption Editor Form -->
            <Tooltip v-if="index == 0" :tooltips="tooltips" name="captions"></Tooltip>

            <!-- Display Caption -->
            <div class="map-post-comment-edit-wrap">

                <div class="map-post-comment-edit on-display">

                    <a :href="`/${list.user.username}`">
                        <img :src="list.user.profile_thumbnail">
                    </a>

                    <!-- Form to Edit -->
                    <div v-if="!hasCaption" class="comment-content">
                        <p class="main-comment">Add a note...</p>
                    </div>

                    <div  v-if="hasCaption && hasLongCaption" class="comment-content">
                        <p class="full-comment" v-if="showingFullCaption">
                            {{ currentSpot.pivot.caption }}
                            <button class="map-comment-shrink" @click="toggleShowCaption()">Less -</button>
                        </p>
                        <p class="main-comment" v-else>
                            {{ strLimit(currentSpot.pivot.caption) }}
                            <button class="map-comment-expand" @click="toggleShowCaption()">More +</button>
                        </p>
                    </div>

                    <div v-if="hasCaption && !hasLongCaption" class="comment-content">
                        <p class="main-comment" v-text="currentSpot.pivot.caption"></p>
                    </div>

                    <form action="#" @submit.prevent="openCaptionEditor()">
                        <button type="submit">
                            Edit
                        </button>
                    </form>
                </div>
            </div>

        </div>

    </div>
</template>
<script>

import Tooltip from '@/components/Tooltip'
import OriginalCaption from '@/components/Lists/Spots/OriginalCaption'

export default {

    props:['index', 'list', 'spot', 'tooltips'],

    components:{
        Tooltip,
        OriginalCaption
    },

    data(){
        return {
            currentSpot: this.spot,
            showingFullCaption: false,
        }
    },

    created() {
        eventBus.$on('spot-' + this.currentSpot.id + '-caption-updated', caption => {
            this.currentSpot.pivot.caption = caption;
        })
    },

    methods:{

        openCaptionEditor(){
            eventBus.$emit('open-edit-caption-dialog', this.currentSpot)
        },

        saveCaption() {
            axios.patch(`/lists/${this.list.id}/spot/${this.currentSpot.slug}/update-caption`, this.currentSpot)
                .then(response => {
                    this.currentSpot = response.data.spot
                })
        },

        toggleShowCaption(){
            this.showingFullCaption = !this.showingFullCaption;
        },

        strLimit(str) {
            return str.substring(0, 100);
        },
    },

    computed: {

        hasCaption() {
            return this.currentSpot.pivot.caption && this.currentSpot.pivot.caption.trim() != '';
        },

        hasLongCaption() {
            if (!this.hasCaption) {
                return false;
            }
            return this.currentSpot.pivot.caption && this.currentSpot.pivot.caption.length > 100;
        },

        isMapBlocked() {
            return window.config.isLoggedIn == false
        },

        ownsList() {
            return window.config.isLoggedIn && window.config.user.id == this.list.user_id;
        },
    },

    beforeDestroy() {
        eventBus.$off('spot-' + this.currentSpot.id + '-caption-updated')
    }
}
</script>
